import type {App} from 'vue';
import type {AppAxiosRequestConfig} from '@/helpers/api';
import {delivery} from '@/api/delivery';

export default {
    install(app: App, options: AppAxiosRequestConfig) {

        delivery.defaults.baseURL = options.baseURL;

        if (options.params) {

            delivery.defaults.params = options.params;
        }

        app.provide("$delivery", delivery);
        app.config.globalProperties.$delivery = delivery;
    }
}